import { StackScreenProps } from "@react-navigation/stack";
import { FlatActionList, Page } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { LlmStrategyFormValues } from "../../components/LlmStrategyForm";
import { useFormContext } from "react-hook-form";
import { View } from "react-native";
import { OpenAiModels } from "./common";

export interface SelectOpenAiModelScreenProps
  extends StackScreenProps<any, "SelectOpenAiModelScreen"> {}

export const SelectOpenAiModelScreen = ({
  navigation,
}: SelectOpenAiModelScreenProps) => {
  const { t } = useTranslation("settings");
  const { getValues, setValue } = useFormContext<LlmStrategyFormValues>();
  const watchedKeyType = getValues("openAiConfig.model");
  const handleOnSelect = (code: string) => {
    setValue("openAiConfig.model", code, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.goBack();
  };
  return (
    <Page
      title={t("title.select_openai_model")}
      secondaryTitle={t("title.select_openai_model_secondary")}
    >
      <View>
        <FlatActionList
          items={OpenAiModels.map((llmType) => ({
            key: llmType.value,
            title: llmType.label,
            subTitle: llmType.description,
            selected: llmType.value === watchedKeyType,
            onPress: () => {
              handleOnSelect(llmType.value);
            },
          }))}
        />
      </View>
    </Page>
  );
};
